<template>
  <section class="settings screen-settings">
    <!---
    <button @click="temp">Take screenshot</button>
    <screenshots-manager/>-->
    <section>
      <header class="p-pb-3">
        <h4>Ontime</h4>
        <div class="p-inputgroup ontime-url">
          <input class="p-inputtext p-component" type="url" v-model="ontimeUrl"/>
          <button class="pure-button pure-button-primary" @click="setOntimeUrl">Save</button>
        </div>
      </header>
      <div class="p-pb-3">
        <input-switch v-model="show_speakers" @change="showSpeakersChanged"/>
        <label>Show Speakers</label>
      </div>
      <header>
        <h4>Screen One</h4>
      </header>
      <div class="p-d-flex p-ai-center">
        <div class="p-pr-3">
          <br />
          <SelectButton
            v-model="screen_one.layout"
            :options="layoutOptions"
            optionLabel="label"
            optionValue="value"
            />
        </div>
      </div>
    </section>
    <!--
    <section>
      <header>
        <h4>Screen Two</h4>
      </header>
      <div class="p-d-flex p-ai-center">
        <div class="p-pr-3">
          <input-switch v-model="screen_two.show_speakers" @change="screenTwoShowSpeakersChanged"/>
        </div>
        <label>Show Speakers</label>
      </div>
    </section>
  -->
  </section>
</template>

<script>
import InputSwitch from 'primevue/inputswitch'
import SelectButton from 'primevue/selectbutton'
import html2canvas from 'html2canvas'
import SpeakersListLayout from '../enums/speakers_list_layout'
import ScreenshotsManager from './screenshots/ScreenshotsManager.vue'

export default {
  name: 'ScreenSettings',
  components: {
    InputSwitch,
    SelectButton,
    ScreenshotsManager
  },
  data: function () {
    return {
      screen_one: {
        show_speakers: this.$store.getters['motions/showSpeakersOnScreen'],
        layout: this.$store.getters['motions/speakersListLayout']
      },
      screen_two: {
        show_speakers: this.$store.getters['motions/showSpeakersOnScreenTwo'],
        layout: this.$store.getters['motions/speakersListTwoLayout']
      },
      ontimeUrl: this.$store.getters['settings/ontimeUrl'],
      show_speakers: this.$store.getters['motions/showSpeakersOnScreen']
    }
  },
  watch: {
    screen_one: {
      handler (newVal, oldVal) {
        this.$store.commit('motions/SET_SPEAKERS_LIST_LAYOUT', newVal.layout)
      },
      // eslint-disable-next-line
      deep: true,
    },
    screen_two: {
      handler (newVal, oldVal) {
        this.$store.commit('motions/SET_SPEAKERS_LIST_TWO_LAYOUT', newVal.layout)
      },
      // eslint-disable-next-line
      deep: true,
    }
  },
  computed: {
    layoutOptions () {
      return [
        {label: 'Carousel', value: SpeakersListLayout.CAROUSEL},
        {label: 'Static', value: SpeakersListLayout.STATIC}
      ]
    },
    shouldShowSpeakers () {
      return this.$store.getters['settings/showSpeakersOnScreen']
    }
  },
  methods: {
    showSpeakersChanged (e) {
      console.log('show speakers changed')
      if (this.show_speakers) {
        this.$store.dispatch('settings/saveShowSpeakers')
      } else {
        this.$store.dispatch('settings/saveHideSpeakers')
      }
      this.$store.commit('motions/SET_SHOW_SPEAKERS_ON_SCREEN', this.show_speakers)
    },
    screenTwoShowSpeakersChanged (e) {
      this.$store.commit('motions/SET_SHOW_SPEAKERS_ON_SCREEN_TWO', this.show_speakers)
    },
    screenOneLayoutChanged (e) {
      console.log('layout chnged')
      this.$store.commit('motions/SET_SPEAKERS_LIST_LAYOUT', this.screen_one.layout)
    },
    screenTwoLayoutChanged (e) {
      this.$store.commit('motions/SET_SPEAKERS_LIST_TWO_LAYOUT', this.screen_two.layout)
    },
    setOntimeUrl (e) {
      this.$store.commit('settings/SET_ONTIME_URL', this.ontimeUrl)
    },
    async temp () {
      const screenshot = await html2canvas(document.body)
      this.$store.dispatch('screenshots/upload', {
        imagedata: screenshot.toDataURL(),

        page: this.$route.name
      })
    }
  }
}
</script>

<style scoped>
.ontime-url {
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreenSettings.vue